import { FormFields } from '@core/data-access/models/form/form-store.model';
import { difference, differenceWith, fromPairs, isEmpty, isEqual, keys, reduce, toPairs } from 'lodash';
import { map, Observable, pairwise, pipe } from 'rxjs';

export const filterChangeFormFieldsPipe = () => {
  return pipe<Observable<FormFields>, Observable<[FormFields, FormFields]>, Observable<FormFields>>(
    pairwise(),
    map(setChangedFormFields)
  );
};

export const setChangedFormFields = ([previousFieldsChange, currentFieldsChange]: [
  previousFieldsChange: FormFields,
  currentFieldsChange: FormFields
]) => {
  const formFieldDifference = differenceWith(toPairs(previousFieldsChange), toPairs(currentFieldsChange), isEqual);
  const addedFormFieldsKeys = difference(keys(currentFieldsChange), keys(previousFieldsChange));

  if (isEmpty(formFieldDifference) && isEmpty(addedFormFieldsKeys)) {
    return [];
  }

  const changedFormFieldKeys = keys(fromPairs(formFieldDifference));
  const changedFormFields = reduce(
    changedFormFieldKeys,
    (changedFormFields, changedFieldKey) => {
      changedFormFields[changedFieldKey] = currentFieldsChange[changedFieldKey];

      return changedFormFields;
    },
    {}
  );

  const addedFormFields = reduce(
    addedFormFieldsKeys,
    (addedFormFields, addedFieldKey) => {
      addedFormFields[addedFieldKey] = currentFieldsChange[addedFieldKey];

      return addedFormFields;
    },
    {}
  );

  const updatedFormFields = { ...changedFormFields, ...addedFormFields };

  return !isEmpty(updatedFormFields) ? updatedFormFields : currentFieldsChange;
};
